import { Component } from '@angular/core';
import { Router, Params } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../core/auth.service';
import { DialogForgetPasswordComponent } from './components/dialog-forget-password/dialog-forget-password.component';
import { Library } from '@core/library';

@Component({
  selector: 'app-page-login',
  templateUrl: 'login.component.html',
  styleUrls: ['login.scss']
})
export class LoginComponent {

  loginForm: FormGroup;
  errorMessage = '';

  constructor(
    public authService: AuthService,
    private router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    public library: Library,
  ) {
    this.createForm();
  }

  createForm() {
    this.loginForm = this.fb.group({
      email: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(DialogForgetPasswordComponent, {
      width: '300px',
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  tryFacebookLogin() {
    this.authService.doFacebookLogin()
      .then(res => {
        this.router.navigate(['/order']);
      });
  }

  tryTwitterLogin() {
    this.authService.doTwitterLogin()
      .then(res => {
        this.router.navigate(['/order']);
      });
  }

  tryGoogleLogin() {
    this.authService.doGoogleLogin()
      .then(res => {
        this.router.navigate(['/order']);
      });
  }

  tryLogin(value) {
    this.library.showloading();
    this.authService.doLogin(value).then(res => {
      this.router.navigate(['/order']);
    }, err => {
      console.log(err);
      this.errorMessage = 'Tên đăng nhập hoặc mật khẩu không đúng.';
    }).finally(() => this.library.hideloading());
  }
}
